import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { RegulationLinksReceived } from "../types";

export const ALL_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED =
    "ALL_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED";
export const ALL_PROPOSED_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED =
    "ALL_PROPOSED_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED";
export const GET_SUB_ACTIVITY_LIST = "GET_SUB_ACTIVITY_LIST";
export const SUB_ACTIVITY_LIST_RECEIVED = "SUB_ACTIVITY_LIST_RECEIVED";
export const TOGGLE_EDITABLE_CURB_LINK = "TOGGLE_EDITABLE_CURB_LINK";
export const SUB_ACTIVITY_RECORD_FETCHED = "SUB_ACTIVITY_RECORD_FETCHED";

export interface ToggleEditableCurbLink {
    type: typeof TOGGLE_EDITABLE_CURB_LINK;
    payload: { isEditCurbLinkEnabled: boolean };
}

export interface EditRegulationPanelState {
    isEditCurbLinkEnabled: boolean;
    curbLinksWithSameRegulationID: RegulationLinksReceived;
}

export interface AllCurbLinksOfSameRegulationIdReceived {
    type: typeof ALL_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED;
    payload: { curbLinks: RegulationLinksReceived };
}

export interface AllProposedCurbLinksOfSameRegulationIdReceived {
    type: typeof ALL_PROPOSED_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED;
    payload: { curbLinks: RegulationLinksReceived };
}

export type EditRegulationTypes =
    | ToggleEditableCurbLink
    | AllCurbLinksOfSameRegulationIdReceived
    | AllProposedCurbLinksOfSameRegulationIdReceived
    | ResetStateAction;
